import {createAsyncThunk} from "@reduxjs/toolkit"
import {AppThunkProps} from "store"
import {api} from "utils/http"

interface ArgsProps {
    id: number
}

type ReturnedType = {
    status: "success"
}

/**
 * Создание меню
 */
export const deleteBasicMenu = createAsyncThunk<ReturnedType, ArgsProps, AppThunkProps>(
    "basic-menu/delete",
    async ({id}, {signal}) => {
        return api.delete<ReturnedType>(`/user/basic-menu/${id}`, {signal})
    }
)
